/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Wrong_VpInputs */



/**
* | output |
* | --- |
* | "What happens if a player self-reports the wrong VP?" |
*
* @param {Og_Faq_Q_Wrong_VpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_wrong_vp = /** @type {((inputs?: Og_Faq_Q_Wrong_VpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Wrong_VpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que se passe-t-il si un joueur saisit des VP incorrects ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué ocurre si un jugador registra los VP incorrectos?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que acontece se um jogador auto-relatar o VP errado?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa succede se un giocatore riporta il VP sbagliato?")
	return /** @type {LocalizedString} */ ("What happens if a player self-reports the wrong VP?")
});